import React, {Component} from 'react';
import Breakpoints from '../utils/breakpoints'
import Radium from 'radium';
import marked from 'marked';
import Link from 'gatsby-link'
import Colors from '../utils/colors'
import {eventDispatch} from '../utils/util-functions'
import {StyleRoot} from 'radium';
import _ from 'lodash';

export class Article extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      linkString: props.path,
      activeLink: props.activeLink
    };
    this.refreshPage = this.refreshPage.bind(this);
    this.goToBooking = this.goToBooking.bind(this);
  }

  refreshPage(){
    window.location.reload();
  }

  goToBooking(name){
    this.props.history.push('/bookingform/#service='+name);
    eventDispatch('hashchange');
  }

  render() {
    const article = _.find(this.props.articles, item => item.url===this.state.activeLink);
    const image = article.item.articleImage ? article.item.articleImage.fields.file.url : null;
    const headline = article.item.articleHeadline;
    const callToAction = article.item.callToAction;
    const introduction = article.item.articleIntroduction;
    const text = article.item.articleText;
    const articles = this.props.articles;
    const articleTypeTitles = articles.map(item => item.item.articleType.fields.title).filter((elem, pos, arr) => arr.indexOf(elem)===pos);
    const path = this.props.path;
    return (
      <div style={styles.main} className="guideArticle">
        <StyleRoot>
          <div className="col-sm-7 col-xs-12">
            {image &&
              <img style={styles.img} src={image} />
            }
            <h1 style={styles.headline}>{headline}</h1>
            <p>{introduction}</p>
            <div>
              { callToAction &&
                <div className="col-xs-12 col-sm-10" style={styles.callToAction} onClick={() => this.goToBooking(callToAction)}>
                  <div style={styles.callToActionText} className="col-sm-10 col-xs-12">{callToAction}</div>
                  <div className="col-xs-2"><i className="glyphicon glyphicon-chevron-right" style={styles.callToActionIcon}></i></div>
                </div>
              }
              <div className="clearfix"></div>
            </div>
            <div dangerouslySetInnerHTML={ {__html: marked(text)} }></div>
          </div>
          <div className="col-xs-12 col-sm-4 col-sm-offset-1" style={styles.sideBar}>
            {articleTypeTitles.map(title =>
              <div key={title}>
                <div className="col-xs-12"> <h2>{title}</h2></div>
                <div style={styles.responsiveDivider}></div>
                <div className="clearfix"></div>
                {articles.map((item, i) => {
                  if (title===item.item.articleType.fields.title){
                    let linkString = "/"+path+"/#article="+item.url;
                    if (this.state.activeLink===item.url) {
                      return (
                          <div key={i}>
                              <Link className="articleItemActive" to={linkString} onClick={this.refreshPage} style={styles.articleListItemActive}>{item.item.articleHeadline}</Link>
                          </div>
                      )
                    } else {
                      return (
                          <div key={i}>
                            <Link to={linkString} onClick={this.refreshPage} style={styles.articleListItem}>{item.item.articleHeadline}</Link>
                          </div>
                      )
                    }
                  }
                })}
              </div>
            )}
          </div>
        </StyleRoot>
      </div>
    );
  }
}

export default Radium(Article);

const styles = {
  main: {

  },
  headline: {
    marginBottom: 40,
    fontFamily: 'Merriweather',
    fontWeight: 'bold',
    lineHeight: 1.4
  },
  img: {
    width: '100%'
  },
  articleListItem:{
    display: 'block',
    padding: 20,
    textDecoration: 'none',
    color: Colors.black,
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 10,
    fontSize: 16,
    paddingRight: 10,
    borderBottom: 'solid'+Colors.lightBrown+' 2px'
  },
  articleListItemActive: {
    display: 'block',
    paddingTop: 34,
    paddingBottom: 26,
    paddingLeft: 25,
    paddingRight: 10,
    marginLeft: -15,
    marginTop: -4,
    fontSize: 16,
    marginBottom: 6,
    textDecoration: 'none',
    color: Colors.black,
    backgroundColor: Colors.lightBrown,
    borderRadius: Breakpoints.borderRadius
  },
  sideBar: {
    borderLeft: 'solid black 1px',
    [Breakpoints.media.siteUnderPadWidth]: {
      borderLeft: 'none',
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
  callToAction:{
    backgroundColor: Colors.darkBlue,
    borderRadius: Breakpoints.borderRadius,
    marginTop: Breakpoints.componentDivider,
    marginBottom: Breakpoints.componentDivider,
    ':hover':{

    }
  },
  callToActionText: {
    padding: 35,
    color: '#ffffff',
    [Breakpoints.media.siteUnderPadWidth]: {
      padding: 20
    }
  },
  callToActionIcon: {
    fontSize: 30,
    padding: 20,
    top: 10,
    color: Colors.mainBlue,
    float: 'right',
    borderBottomRightRadius: Breakpoints.borderRadius,
    borderTopRightRadius: Breakpoints.borderRadius,
    backgroundColor: '#ffffff',
    [Breakpoints.media.siteUnderPadWidth]: {
      display: 'none'
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/GuideArticle.js